
import { window } from 'globalthis/implementation';
import React, { useEffect } from 'react';
import View from "./view"
import Page from "src/components/Page";
import { Helmet } from 'react-helmet';
function index(props) {
    // localStorage.removeItem("@storeAuctionLot");

    

    return (
        <>

<Helmet>
<meta itemprop="name" content="Exclusive Art Sale | Private Paintings at Leon Gallery" />
<meta property="og:title" content="Exclusive Art Sale | Private Paintings at Leon Gallery" />
<meta name="twitter:title" content="Exclusive Art Sale | Private Paintings at Leon Gallery" />
<meta itemprop="description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." /> 
<meta property="og:description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." />  
<meta name="twitter:description" content="Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities." />
<meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
<meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
<meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
</Helmet>
        <Page title="Private Sale Leon Gallery | Leon Gallery Premier Art Auction House in the Philippines">
            <View/>
        </Page>
        </>
    );
}

export default index;